import { render, staticRenderFns } from "./HostingCharts.vue?vue&type=template&id=ed37fc1a&"
import script from "./HostingCharts.vue?vue&type=script&lang=js&"
export * from "./HostingCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports